"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.roundedCountriesCount = void 0;
/** if countries number less than 90 round to 90, other round to nearest lower number divisible by 10 */
const roundedCountriesCount = (countriesCount) => {
    if (!countriesCount) {
        return 90;
    }
    return countriesCount > 90 ? Math.floor(countriesCount / 10) * 10 : 90;
};
exports.roundedCountriesCount = roundedCountriesCount;
//# sourceMappingURL=countryNumberRounding.js.map